enum FormFieldType {
    Field = 1,
    Container = 2,
}

export default FormFieldType;
